import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../authProvider/authProvider";

import React from "react";
import { CircularProgress } from "@mui/material";

const TANDCDATE = new Date("2025-12-31T00:00:00.000Z");
type AuthProps = {
  allowedRoles: string[];
  extraPermissions?: string[];
  // tileAccess2: string[];
};

const Auth: React.FunctionComponent<AuthProps> = (props) => {
  const { allowedRoles, extraPermissions } = props;
  const context = useContext(AuthContext);
  const location = useLocation();
  if (!context) {
    throw new Error(`Auth context is undefined`);
  }

  //console.log(AuthContext)
  const {
    role,
    currentUser,
    loading,
    hasMultiFactor,
    tileAccess,
    acceptedTCDate,
    hasDataStudioAccess,
    canViewFormSubmissions,
  } = context;
  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </div>
    );
  }

  console.log("CHECKING LOCATION BASENAME: ", location.pathname);
  // console.log(currentUser);
  if (currentUser != null && currentUser !== undefined) {
    if (tileAccess != null || tileAccess !== undefined) {
      if ((tileAccess != null || tileAccess !== undefined) && tileAccess.includes(location.pathname)) {
        return <Navigate to="/basepage" state={{ from: location }} replace />;
      }
    }
  }

  function checkExtraPermissions() {
    if (extraPermissions) {
      for (const permission of extraPermissions) {
        console.log("Checking extra permission: " + permission);
        if (permission === "hasDataStudio") {
          if (!hasDataStudioAccess) {
            console.log("Does not have data studio access: " + hasDataStudioAccess);
            return false;
          }
        } else if (permission === "canViewFormSubmissions") {
          if (!canViewFormSubmissions) {
            console.log("Does not have can view form submissions access: " + canViewFormSubmissions);
            return false;
          }
        } else {
          return false;
        }
      }
    }
    return true;
  }

  return currentUser ? (
    loading || hasMultiFactor === null ? (
      <CircularProgress />
    ) : !hasMultiFactor && location.pathname != "/mfaEnroll" && location.pathname != "/confirmMFAEnroll" ? (
      <Navigate to="/mfaEnroll" state={{ from: location }} replace />
    ) : (!acceptedTCDate || acceptedTCDate < TANDCDATE) &&
      location.pathname != "/termsAndConditions" &&
      location.pathname != "/mfaEnroll" &&
      location.pathname != "/confirmMFAEnroll" ? (
      <Navigate to="/termsAndConditions" state={{ from: location }} replace />
    ) : (allowedRoles.length == 0 || allowedRoles.find((allowedRole) => role === allowedRole)) &&
      checkExtraPermissions() ? (
      // auth.role.find(role => allowedRoles?.includes(role))
      <Outlet />
    ) : (
      <Navigate to="/unauthorized" state={{ from: location }} replace />
    )
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default Auth;
